import React from 'react';
const stats = [{
  value: '+500',
  label: 'Estudiantes confían'
}, {
  value: '12',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'Calificación ⭐'
}];
export function Stats() {
  return <section aria-label="Resultados reales" className="bg-ink-2 border-y border-white/5" data-id="element-165" data-mp="2ixpcctdt751d">
      <div className="mx-auto max-w-5xl px-5 py-10 pt-[0px] pb-[0px]" style={{
      paddingBottom: "27px"
    }} data-id="element-166" data-mp="2nvh3vmajkp51">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4 pb-[7px] pt-[18px]" style={{
        paddingTop: "31px",
        paddingBottom: "0px",
        marginTop: "-25px",
        marginBottom: "-25px"
      }} data-id="element-167" data-mp="296uo5jh05vda">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-168" data-mp="205d11h56gtf3">
              <dt className="font-display text-4xl font-black text-white sm:text-5xl" data-id="element-169" data-mp="257lvyj1m25ju">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-170" data-mp="1qabbwlawjrci">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}